import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { CompanySchema, type Company } from "./organizationSchema";

export const supplierParentOrganizationsKey = "supplierParentOrganizations" as const;

type Options = {
    searchText?: string;
    enabled?: boolean;
    itemsPerPage?: number;
};

export const useSupplierParentOrganizations = (options: Options = {}) => {
    const { searchText = "", enabled = true, itemsPerPage = 200 } = options;

    const query = useQuery<Company[], Error>({
        queryKey: [supplierParentOrganizationsKey, searchText, itemsPerPage],
        queryFn: async () => {
            const response = await loggedInApiCall.get<{ "hydra:member": unknown }>(
                "/api/suppliers/parent-organizations",
                {
                    params: {
                        q: searchText,
                        itemsPerPage,
                        order: { name: "ASC" },
                    },
                },
            );

            return zodParseWithLog(
                response.data["hydra:member"],
                CompanySchema.array(),
                supplierParentOrganizationsKey,
            );
        },
        enabled,
        staleTime: 0,
        cacheTime: 5 * 60 * 1000,
    });

    const { isLoading, error, ...rest } = query;

    return {
        companies: query.data || [],
        isLoading,
        error,
        ...rest,
    };
};
